<template>
  <div class="accordion">
    <div class="accordion__header">
      <slot name="header" :toggle="toggle"></slot>
    </div>
    <transition
      name="expand"
      @enter="enter"
      @after-enter="afterEnter"
      @leave="leave"
    >
      <div v-show="open" class="accordion__body" :aria-hidden="!open">
        <slot name="body"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "ConfettiAccordion",
  props: {
    open: {
      type: Boolean,
    },
  },
  methods: {
    toggle() {
      this.$emit("update:open", !this.open);
    },
    enter(element) {
      element.style.height = "auto";

      const height = getComputedStyle(element).height;

      element.style.height = 0;

      requestAnimationFrame(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
    leave(element) {
      element.style.height = getComputedStyle(element).height;

      requestAnimationFrame(() => {
        element.style.height = 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion {
  &__header {
    font-size: 2.1rem;
    font-weight: 300;
    padding: 1rem;
  }

  &__body {
    padding: 1rem;
  }
}

.expand-enter-active,
.expand-leave-active {
  overflow: hidden;
  transition: block-size 150ms ease-in-out;
}

.expand-enter,
.expand-leave-to {
  block-size: 0;
}
</style>
